import React, { useEffect } from 'react';
import { Typography } from '@material-ui/core';
import { SET_VALUE } from '../formReducer';

interface Props {
  item: any;
  value: any;
  formDispatch: any;
  formId: string;
}

const NumberFieldComponent: React.FC<Props> = ({ item, value, formDispatch, formId }) => {
  useEffect(() => {
    formDispatch({ type: SET_VALUE, payload: { formId, fieldId: item.name, value } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formId, item?.name]);

  const label = item?.label || item?.name;

  return (
    <Typography variant="body2">
      <strong>{label}:</strong> {value !== undefined && value !== null ? String(value) : ''}
    </Typography>
  );
};

export default NumberFieldComponent;
